<template>
  <div class="layout">
    <Header1></Header1>
    <div class="main-content">
      <router-view />
    </div>
  </div>
</template>

<script>
import Header1 from "./Header1.vue";
export default {
  components: {
    Header1,
  },
  data() {
    return {};
  },
  mounted() {},
};
</script>

<style>
.layout {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.main-content {
  flex: 1;
}
</style>
